<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'app',
  };
</script>

<style lang='scss'>
  @import './variables';

  @font-face {
    font-family: "Ginger";
    src: url("./fonts/F37Ginger-Regular.otf") format("opentype");
    font-weight: normal;
    font-style: normal;
  }  
  
  @font-face {
    font-family: "Ginger";
    src: url("./fonts/F37Ginger-Regular.otf") format("opentype");
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: "Ginger";
    src: url("./fonts/F37Ginger-Bold.otf") format("opentype");
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: "Ginger";
    src: url("./fonts/F37Ginger-Black.ttf") format("truetype");
    font-weight: 900;
    font-style: normal;
  } 


  body {
    margin: 0;
    overflow-x: hidden;
  }
  #app {
    // font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-family: 'Ginger', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #ffffff;
    line-height: 1;
    height: 100vh;
  }
  section {
    font-size: 0;
  }
  a {
    color: $bubly-white;
    transition: color .2s ease-in;
    text-decoration: none;

    &:hover {
      color: $bubly-white-hover;
    }
  }
  .skip-to-content-link {
    position: absolute;
    display: block;
    background-color: $bubly-blue;
    margin: 0 auto;
    left: 0;
    right: 0;
    top: -60px;
    padding: 15px;
    color: #000;
    text-decoration: underline;

    &:focus {
      position: relative;
      top: 0;
    }
  }



  .btn {
    display: inline-block;    
    margin: 10px;
    padding: 7px 20px;
    box-sizing: border-box;
    text-align: center;
    border: 2px solid #FFF;
    border-radius: 20px;
    font-size: 18px;
    cursor: pointer;

    &:hover {
      background-color: #fff;
    }
  }
  img {
    max-width: 100%;
  }
  .fa-icon {
    width: auto;
    height: 1em;

    /* Safari */
    max-width: 100%;
    max-height: 100%;
  }

  /*
   * Flex Grid 
   */

  .Grid {
    display: flex;
    flex-direction: column;
  }

  @include breakpoint('tablet') {

    .Grid {
      flex-direction: row;
    }
    .Grid-cell {
      flex: 1;
    }
    .Grid--1of2 > .Grid-cell {
      flex: 0 0 50%
    }
    .Grid--1of3 > .Grid-cell {
      flex: 0 0 33.3333%
    }
    .Grid--1of4 > .Grid-cell {
      flex: 0 0 25%
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue